<template>
  <div>
    <!----------------- Main contents Area --------------------->
    <!-- mt-3: margin top-3 -->
    <main class="mt-3">
      <div class="container">
        <div class="alert alert-secondary" role="alert">
          <b class="fs-4">지역관리<span style="font-size:small; color: red;">※일본국 도도부현은 임의생성이 불가능합니다</span> </b>
        </div>
        <div style="display: flex; width:100%;">
          <div style="width: 60%; margin-right: 1%;">
            <div>
              <label class="text-danger">[ 일본국 도도부현 리스트 ]</label>
            </div>
            <table class="table table-bordered table-striped fs-6 align-item-atart text-center">
              <thead class="small">
                <tr>
                  <th style="width:10%;">순서</th>
                  <th style="width:10%">코드</th>
                  <th style="width:15%">국문명</th>
                  <th style="width:15%">일문명</th>
                  <th style="width:15%">영문명</th>
                  <th style="width:15%">사용여부</th>
                  <th style="width:10%">변경</th>
                </tr>
              </thead>
              <tbody class="small">
                <tr :key="i" v-for="(m, i) in baseCodeList">
                  <td>
                    <input type="number" class="form-control-sm text-end" v-model="m.sort_order" style="width:100px;">
                  </td>
                  <td>
                    {{ m.region_id }}
                  </td>
                  <td>
                    {{ m.pref_name_ko }}
                  </td>
                  <td>
                    {{ m.pref_name_jp }}
                  </td>
                  <td>
                    {{ m.state_province }}
                  </td>                                    
                  <td>
                    <select class="form-select form-select-sm" aria-label=".form-select-sm" ref="sel_pUseFlag" v-model="m.use_flag">
                      <option value="Y" class="text-success">Y</option>
                      <option value="N" class="text-danger">N</option>
                    </select>
                  </td>
                  <td>
                    <button type="button" class="btn btn-outline-primary btn-sm" style="font-size: small;" @click="update_arInfo(m.sort_order, m.use_flag, m.region_id)">변경</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  // DB에서 가져온 데이타
  data() {
    return {
      baseCodeList: [],           //기본코드리스트
      // baseCodeList_ar_jp: [],     //일본지역
      // baseCodeList_nt_et: [],     //그 외 국가코드
    };
  },
  created() {
    //this.productId = this.$route.query.productId;
    this.user = this.$store.state.user;

    this.getPerfecturesList()
  }, 

  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  mounted() {
    if(document.referrer == "") {
      this.$swal.fire('', '적절하지 않은 페이지 접근입니다.', 'error');
      location.replace("/")
    }
    //권한없는 로그인 차단
    if(this.user.handlerGrade >= 20) {
      var swal = require('sweetalert2');
      swal.fire({
        title: '로그인 필요',
        text: '접근권한 확인불가.',
        icon: 'error'
      });
      this.$router.push({path: '/'});
    }
    ////document.getElementById("notice").style.display = "none";
    document.getElementById("user").style.display = "none";    
  },
  methods: {
    getDateFormat(date) {
      return this.$dateFormat(date);
    },

    async getPerfecturesList() {
      let baseCodeList = await this.$api("/api/perfectrureList", { param: ["JP"] })
      
      if(baseCodeList.length > 0)
      {
        this.baseCodeList = baseCodeList
      }

      // console.log("baseCodeList>>>>", this.baseCodeList)
    },

    // update_arInof(m.sort, m.useFlag, m.baseCode, m.categoryCode, m.primeCatCode)
    async update_arInfo(sort, useFlag, regId){
      let upd_baseCodeInfo = await this.$api("/api/upd_perfectrureList", {param: [
        sort, useFlag, regId
      ]})
      //console.log("upd_baseCodeInfo:", upd_baseCodeInfo)
      if(upd_baseCodeInfo.affectedRows > 0)
      {
        this.$swal.fire("","변경이 완료되었습니다,", "success")
        .then(() => {
          // location.reload(true)
          this.getPerfecturesList()
        })
      }
    },
  }
}
</script>